import { ArrowInCircleRightIcon } from '@vlabs/icons';
import { IconButton } from '@vlabs/uikit/components/controls/button/icon-button';
import type { IconButtonProps } from '@vlabs/uikit/components/controls/button/icon-button';
import { usePageAccess } from '@vlabs/permissions';
import { routes } from '@vlapps/point/src/app/routes';
import { generatePath, Link } from 'react-router-dom';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import type { GoToUserProps } from './types';

type GoToUserIconButtonProps = GoToUserProps & IconButtonProps;

const displayName = 'GoToUserIconButton';
const testid = buildTestid(displayName);

function GoToUserIconButton({
  userId,
  'data-testid': dataTestId = undefined,
  ...props
}: GoToUserIconButtonProps): JSX.Element | null {
  const hasAccess = usePageAccess('users_details');
  if (!hasAccess) return null;

  return (
    <IconButton
      as={Link}
      icon={<ArrowInCircleRightIcon />}
      kind="secondary"
      to={() => generatePath(routes.users.view, { userId })}
      variant="flat"
      {...testid(dataTestId)}
      {...props}
    />
  );
}

GoToUserIconButton.displayName = displayName;

export { GoToUserIconButton };
